import { useRef as d, useLayoutEffect as a, useState as x } from "react";
import { DescendantsManager as m } from "./descendant.js";
import { cast as r } from "./utils.js";
import { createContext as D } from "../../../utils/react/context.js";
import { useMergeRefs as l } from "../../../utils/hooks/useMergeRefs.js";
const C = () => {
  const n = d(new m());
  return a(() => () => n.current.destroy()), n.current;
}, [I, u] = D({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
}), g = (n) => {
  const t = u(), [s, o] = x(-1), e = d(null);
  a(
    () => () => {
      e.current && t.unregister(e.current);
    },
    []
  ), a(() => {
    if (!e.current)
      return;
    const c = Number(e.current.dataset.index);
    s !== c && !Number.isNaN(c) && o(c);
  });
  const i = n ? r(t.register(n)) : r(t.register), f = l(i, e);
  return {
    descendants: t,
    index: s,
    enabledIndex: t.enabledIndexOf(e.current),
    register: f
  };
}, M = () => [
  r(I),
  () => r(u()),
  () => C(),
  (e) => g(e)
];
export {
  M as createDescendantContext
};
//# sourceMappingURL=useDescendant.js.map
